import React, { useEffect, useState } from "react";
import MyContext from "../../../../../api/context/my-context";

import * as GC from "../../../../common/common";
import * as CommonFunctions from "../functions/commonFunctions";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";
import $ from "jquery";

/**
 * @returns contex'i döndürür
 */
function useContext() {
  const context = React.useContext(MyContext.Consumer);
  if (context === undefined) {
    throw new Error("useCount must be used within a CountProvider");
  }
  return context;
}

const VerwijderUitvoering = () => {
  var selectedIdsState = [];
  var context = useContext();

  useEffect(() => {
    // uygulama ilk çalıştığında waitProcess state'lerini temizliyoruz
    context.actions.actionStartProcess(null);
    // returned function will be called on component unmount
    // bu fonksiyon class compnent'teki  "componentWillMount()" gibi çalışır
    return () => {
      context.actions.actionStartProcess(null);
    };
  }, []);
  var selectedRowDefinition = [];

  const handleSubmit = async () => {
    selectedRowDefinition = [];

    await $("#cover-spin").show(0);

    var selectedIds = [];
    $("#example")
      .dataTable()
      .$("tr.selected")
      .each(function () {
        selectedIds.push($(this).attr("rowId"));
      });

    /**
     * * process kontrol için 1. adım
     * * kayıttan önce tüm satırların stagelistleri alınır.
     */

    for (let i = 0; i < selectedIds.length; i++) {
      const id = selectedIds[i];

      for (let j = 0; j < window.$mm_work_plans_Glist.length; j++) {
        const rowList = window.$mm_work_plans_Glist[j];
        if (id == rowList.identification) {
          /**
           * * seçilmiş satırların sırası ile stage listleri çekilir
           */
          await omnimap
            .GetActionsOfRowSingleAction(id, window.$mm_management_units_token)
            .then(async (result) => {
              const listItem = {
                stageList: result.data.stages_list,
                id: id,
                rowItem: rowList,
              };
              selectedRowDefinition.push(listItem);
            });
          break;
        }
      }
    }

    // /**
    //  * * process kontrol için 1. adım
    //  * * kayıttan önce tüm satırların stagelistleri alınır.
    //  */

    // for (let i = 0; i < selectedIds.length; i++) {
    //   const id = selectedIds[i];
    //   /**
    //    * * seçilmiş satırların sırası ile stage listleri çekilir
    //    */
    //   await omnimap
    //     .GetActionsOfRowSingleAction(id, window.$mm_management_units_token)
    //     .then(async (result) => {
    //       const listItem = { stageList: result.data.stages_list, id: id };
    //       selectedRowDefinition.push(listItem);
    //     });
    // }

    var model = { action: "DELETE" };

    await GC.StartActivity(
      model,
      selectedIds,
      "b57232b9-090e-45f8-9729-3c768e12f650",
      VerwijderUitvoeringCallBack,
      window.$mm_management_units_token
    );

    await GC.waitProcess(
      "Verwijder uit uitvoering",
      null,
      selectedRowDefinition,
      context,
      selectedIds.length
    );
  };

  const VerwijderUitvoeringCallBack = () => {
    GC.sleep(900).then(() => {
      $("#verwijder_uitvoering").modal("hide");
      window.$mm_work_plans_refresh();
      /*omnimap
        .FillTableAction(
          window.$mm_work_plans_lastUsedTableFilter,
          1,
          window.$mm_management_units_token
        )
        .then((result) => {
          CallBackFunctions.FillTableCallBack(result, 1);
        });*/
    });
  };

  return (
    <div
      className="modal fade"
      tabIndex={-1}
      role="dialog"
      id="verwijder_uitvoering"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Verwijder uit uitvoering</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body">
            <h1>Toelichting</h1>
            <p>Let op: niet gesynchroniseerde data gaat verloren</p>
          </div>
          <div className="modal-footer">
            <MyContext.Consumer>
              {(context) => (
                <button
                  type="button"
                  id="save_wijzig_status"
                  className="btn-modal"
                  // onClick={handleSubmit}
                  onClick={(event) => {
                    context.actions.actionStartProcess({
                      successRowCount:
                        window.$mm_work_plans_table_selected_row_count,
                      errorRowCount: 0,
                      completeSuccess: true,
                      completeError: false,
                    });
                    handleSubmit();
                  }}
                >
                  Verwerken
                </button>
              )}
            </MyContext.Consumer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerwijderUitvoering;
